import React from 'react'

import { Card } from 'components'

import { DimensionScoreChart } from '.'

export const ReportDimensionalScoreCard = ({ loading, report, ...props }) => (
  <Card {...props} heading='Avaliação dimensional'>
    <DimensionScoreChart loading={loading} dimensionScores={report?.dimensionScores} />
  </Card>
)

export default ReportDimensionalScoreCard
